<div class="jumbotron bg-gray-50 py-6">
  <div class="container-xl">
    <div class="d-flex">
      <img src="assets/images/help.svg" alt="Help Center image" class="me-5" />
      <div class="flex-fill align-self-center">
        <h1 class="my-0">Help Center</h1>
        <h2 class="my-0">Find Answers to Your Questions</h2>
      </div>
    </div>
  </div>
</div>
<div class="container-xl">
  <h3 class="mb-5 mt-7">Popular Topics &amp; Questions</h3>
  <div class="row">
    <div class="col-sm-12 col-md-6 col-lg-4" *ngFor="let data of helpData">
      <div class="h-100 mb-6">
        <div class="d-flex mb-5">
          <img
            [src]="data.categoryImg"
            alt="{{ data.categoryTitle }}"
            class="me-4"
          />
          <h4 class="flex-fill align-self-center text-dark my-0">
            {{ data.categoryTitle }}
          </h4>
        </div>
        <p class="lc-dt" *ngFor="let featured of data.featuredFAQ">
          <a [routerLink]="['/q-and-a/' + convertDotToSlash(featured.questionId)]" class="text-dark"
            ><u [innerHTML]="featured.question"></u></a
          >
        </p>
        <a [routerLink]="['/category', data.categoryId]"
          >More<i class="material-icons-round">chevron_right</i></a
        >
      </div>
    </div>
  </div>
</div>
